module.exports = __webpack_public_path__ + "static/zdjęcia11-a87ce0f4f434faf29a80bafe8d65b024.svg";